"use client";
import { useRouter, usePathname } from "next/navigation";
import { useState, startTransition, useEffect } from "react";

interface InstantLoadingButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onBeforeNavigate?: () => void; // WorkCard에서 사용할 콜백
  disableScaleAnimation?: boolean; // 스케일 애니메이션 비활성화 옵션 추가
}

export function InstantLoadingButton({
  href,
  children,
  className = "",
  onBeforeNavigate,
  disableScaleAnimation = false, // 기본값은 false (기존 동작 유지)
}: InstantLoadingButtonProps) {
  const router = useRouter();
  const pathname = usePathname();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [pathname]);

  const handleClick = () => {
    if (pathname === href) return;

    // 네비게이션 전 콜백 실행 (WorkCard에서 setWork 호출용)
    onBeforeNavigate?.();

    setIsLoading(true);

    startTransition(() => {
      router.push(href);
    });

    setTimeout(() => {
      setIsLoading(false);
    }, 20000);
  };

  // 스케일 애니메이션 관련 클래스를 조건부로 적용
  const scaleClasses = disableScaleAnimation
    ? ""
    : "hover:scale-105 active:scale-95";

  // transition 클래스도 조건부로 적용
  const transitionClasses = disableScaleAnimation
    ? "transition-colors duration-150"
    : "transition-all duration-150";

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`${className} ${transitionClasses} ${
        isLoading ? "opacity-70 cursor-wait" : scaleClasses
      }`}
    >
      {children}
    </button>
  );
}
